import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export class Translation {
  constructor() {
    this._els = document.querySelectorAll('[appear-translation]');

    if (this._els.length) {
      this.init()
    }
  }

  init() {
    this._els.forEach((el) => {
      let type = el.getAttribute('appear-type') ?? null;


      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: el,
          start: 'top bottom-=15%',
          end: 'top bottom-=50%',
          toggleActions: 'play none none reverse',
          scrub: 1,
        }
      })


      tl.fromTo(el,
        {
          y: 50,
          opacity: 0
        },
        {
          opacity: 1,
          y: 0,
        }
      )

    });
  }
}
